/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbReturns_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": "PdpSharedBlurbReturns_user";
};
export type PdpSharedBlurbReturns_user$data = PdpSharedBlurbReturns_user;
export type PdpSharedBlurbReturns_user$key = {
    readonly " $data"?: PdpSharedBlurbReturns_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbReturns_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbReturns_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '871381ffb25bb95935181a3c9bb6907a';
export default node;
